import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Flex, HStack, Table, Tbody, Td, Tr, VStack, useDisclosure } from '@chakra-ui/react';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PageWrapper, ToolCard } from '@/components';
import { REGEX } from '@/utils';
import { ToolsProvider, useTools } from './context/ToolsContext';
import { ModalBlink, ModalShift } from './fragments';
export const TimeWarp = () => {
    return (_jsx(ToolsProvider, { children: _jsx(TimeWarpContent, {}) }));
};
const TimeWarpContent = () => {
    const { t } = useTranslation();
    const { info, status } = useTools();
    const shiftModal = useDisclosure();
    const blinkModal = useDisclosure();
    const statusList = useMemo(() => {
        if (!status)
            return [];
        const { current_phase, segments, study_day } = status;
        const items = [
            { label: 'uMotif Code', value: REGEX.UMOTIF_CODE(info.uMotifCode) },
            { label: 'Time Zone', value: info.timeZone },
            { label: 'Study Day', value: study_day.current_study_day },
            { label: 'Study Phase', value: current_phase.name },
            { label: 'Segment(s)', value: segments.map((s) => s.name) }
        ];
        return items.filter(({ value }) => {
            if (value == null)
                return false;
            if (typeof value === 'string' && value.trim() === '')
                return false;
            if (Array.isArray(value) && value.length === 0)
                return false;
            return true;
        });
    }, [status, info]);
    const StatusView = memo(() => {
        const renderValue = (value) => {
            if (Array.isArray(value)) {
                return (_jsx(HStack, Object.assign({ flexWrap: 'wrap' }, { children: value.map((v, i) => (_jsx(Badge, Object.assign({ fontSize: 'sm', fontWeight: 'normal', textTransform: 'capitalize' }, { children: v }), i))) })));
            }
            return value;
        };
        return (_jsx(Table, Object.assign({ size: 'sm', variant: 'simple' }, { children: _jsx(Tbody, { children: statusList.map(({ label, value }, index) => (_jsxs(Tr, { children: [_jsx(Td, Object.assign({ fontWeight: 'bold', verticalAlign: 'top', w: '1%', whiteSpace: 'nowrap' }, { children: label })), _jsx(Td, { children: renderValue(value) })] }, index))) }) })));
    });
    return (_jsxs(PageWrapper, Object.assign({ description: t('page:tool.time-warp.description'), title: t('page:tool.time-warp.title') }, { children: [_jsxs(VStack, Object.assign({ spacing: '8' }, { children: [_jsx(StatusView, {}), _jsxs(Flex, Object.assign({ direction: { base: 'column', md: 'row' }, gap: '8', w: '100%' }, { children: [_jsx(ToolCard, { buttonProps: {
                                    bgColor: 'darkBrandBlue.80'
                                }, buttonText: t('page:tool.time-warp.shift.btn-view'), description: t('page:tool.time-warp.shift.description'), flex: '1', icon: 'calendar-shift', onClick: shiftModal.onOpen, title: t('page:tool.time-warp.shift.title') }), _jsx(ToolCard, { buttonProps: {
                                    bgColor: 'darkBrandBlue.40'
                                }, buttonText: t('page:tool.time-warp.blink.btn-view'), description: t('page:tool.time-warp.blink.description'), flex: '1', icon: 'calendar-blink', onClick: blinkModal.onOpen, title: t('page:tool.time-warp.blink.title') })] }))] })), _jsx(ModalShift, { isOpen: shiftModal.isOpen, onClose: shiftModal.onClose }), _jsx(ModalBlink, { isOpen: blinkModal.isOpen, onClose: blinkModal.onClose })] })));
};
